function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getValue, appendPath, parentPath } from '@truqc/content-path';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import { equals } from 'ramda';
import moment from 'moment';
import DateTimePicker from '../../common/controls/dateTimePicker';
import { enabledSelector, labelSelector, valueSelector } from '../selectors/index';
import entityComposition from '../../common/classes/entityComposition';
import Label from './label';
import { getContent } from '../selectors/simpleSelectors';
// import logValueOnChange from '../selectors/logValueOnChange';

const createDays = endingDate => {
  const momentEndingDate = moment(endingDate);
  const days = {};
  for (let i = 6; i >= 0; i -= 1) {
    const date = momentEndingDate.clone().subtract(i, 'days');
    const key = moment.utc(date).toISOString();
    days[key] = {
      title: moment.utc(date).format('MM/DD/YYYY'),
      _created: key
    };
  }
  return days;
};
const removeDays = (oldDays = {}) => {
  const result = {};
  // Clear all the old days
  Object.keys(oldDays).forEach(key => {
    result[key] = null;
  });
  return result;
};
const WeekEndingField = ({
  setCurrentDateOnUpdateToContentPath: _setCurrentDateOnUpdateToContentPath = null,
  testingIdentifier: _testingIdentifier = 'default-id',
  daysContentPath: _daysContentPath = null,
  label: _label = null,
  value: _value = null,
  contentPath,
  onChange,
  content,
  enabled,
  path
}) => {
  let valueInContent = _value;
  if (_setCurrentDateOnUpdateToContentPath) {
    valueInContent = getValue(_setCurrentDateOnUpdateToContentPath, content);
  }
  const handleChange = date => {
    const endOfDay = moment.utc(date).endOf('day').milliseconds(0);
    const fullPath = contentPath.startsWith('/') ? contentPath : appendPath(parentPath(path), contentPath);
    const newValue = endOfDay.toISOString();
    onChange({
      path: fullPath,
      value: newValue,
      displayValue: newValue
    });
    if (_daysContentPath) {
      const fullDayPath = _daysContentPath.startsWith('/') ? _daysContentPath : appendPath(parentPath(path), _daysContentPath);
      const oldDays = removeDays(getValue(fullDayPath, content));
      const newDays = createDays(endOfDay);
      const days = _objectSpread(_objectSpread({}, oldDays), newDays);
      onChange({
        path: fullDayPath,
        value: days
      });
    }
  };
  const [lastContentValue, setLastContentValue] = useState(valueInContent);
  if (!equals(lastContentValue, valueInContent) && valueInContent) {
    setLastContentValue(valueInContent);
    if (!_value) {
      handleChange(moment.utc().endOf('isoWeek').toISOString());
    }
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Label, {
    value: _label
  }), enabled ? /*#__PURE__*/React.createElement(DateTimePicker, {
    onChange: handleChange,
    defaultValue: _value,
    className: kebabCase(_testingIdentifier),
    isValidDate: current => current.day() === 0
  }) : /*#__PURE__*/React.createElement("div", {
    className: kebabCase(_testingIdentifier)
  }, moment(_value).format('MM/DD/YYYY')));
};
WeekEndingField.propTypes = {
  content: PropTypes.shape({}).isRequired,
  contentPath: PropTypes.string.isRequired,
  daysContentPath: PropTypes.string,
  enabled: PropTypes.bool.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  setCurrentDateOnUpdateToContentPath: PropTypes.string,
  testingIdentifier: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({}), PropTypes.array])
};
export { WeekEndingField as UncomposedWeekEndingField };
export default entityComposition(WeekEndingField, [], {
  enabled: enabledSelector,
  label: labelSelector,
  value: valueSelector,
  // onChange: logValueOnChange,
  content: getContent
});